import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLanguage, translations } from "../components/LanguageContext";
import { useState, useEffect } from "react";

export default function Footer() {
  const { t, currentLanguage } = useLanguage();
  
  // Auto-detect Vietnamese users for Facebook link (Update #13 - 2025-08-20, Updated 2025-11-09)
  // Logic: Vietnamese language selected → Vietnamese Facebook page, Other languages → Disabled with "Coming Soon"
  const [isVietnamese, setIsVietnamese] = useState(false);
  
  useEffect(() => {
    // Check if Vietnamese language is selected
    if (currentLanguage === 'vi') {
      setIsVietnamese(true);
      console.log('Vietnamese Facebook: Language is Vietnamese');
    } else {
      setIsVietnamese(false);
      console.log('Main Facebook: Language is not Vietnamese');
    }
  }, [currentLanguage]);

  return (
    <footer className="bg-gradient-to-b from-slate-50/30 to-slate-100/10 border-t border-slate-200/60 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-12 space-y-8">
          {/* Footer Links */}
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
            <Link 
              to="/privacy-policy"
              className="text-muted-foreground hover:text-slate-800 transition-colors duration-300 text-sm"
            >
              {t('footer.privacyPolicy')}
            </Link>
            <Link 
              to="/terms-of-use"
              className="text-muted-foreground hover:text-slate-800 transition-colors duration-300 text-sm"
            >
              {t('footer.termsOfUse')}
            </Link>
            {/* TEMPORARY: Cookie Policy link hidden (Update #14 - 2025-08-20) */}
            {/* Original code - uncomment to re-enable Cookie Policy link
            <Link 
              to="/cookie-policy"
              className="text-muted-foreground hover:text-slate-800 transition-colors duration-300 text-sm"
            >
              {t('footer.cookiePolicy')}
            </Link>
            */}
          </div>

          {/* Social Media Icons */}
          <div className="flex justify-center items-center gap-6">
            <a
              href="https://z-creative-partners.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 rounded-lg hover:bg-slate-100/50 transition-all duration-300 group hover:scale-110"
              aria-label={t('accessibility.ariaHomepage')}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="text-muted-foreground group-hover:text-slate-800">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" strokeWidth="2"/>
                <polyline points="9,22 9,12 15,12 15,22" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </a>

            <a
              href={translations.socialMediaLinks?.instagram[currentLanguage] || translations.socialMediaLinks?.instagram.en}
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 rounded-lg hover:bg-slate-100/50 transition-all duration-300 group hover:scale-110"
              aria-label={t('accessibility.ariaInstagram')}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="text-muted-foreground group-hover:text-slate-800">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="currentColor" strokeWidth="2"/>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" stroke="currentColor" strokeWidth="2"/>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </a>

            <a
              href={isVietnamese ? 'https://www.facebook.com/ZCreativePartnersVietNam' : 'https://www.facebook.com/profile.php?id=61583350621222'}
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 rounded-lg hover:bg-slate-100/50 transition-all duration-300 group hover:scale-110"
              aria-label={t('accessibility.ariaFacebook')}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="text-muted-foreground group-hover:text-slate-800">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </a>
          </div>

          {/* Copyright */}
          <motion.div 
            className="text-center border-t border-slate-200/60 pt-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <p className="text-sm text-muted-foreground">
              {t('footer.copyright')}
            </p>
          </motion.div>
        </div>
      </div>
    </footer>
  );
}